import React, { useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import SubTab from './../SubTab/SubTab';

const LocalYouthJob = () => {
  const category = 'LocalYouthJob';
  const [dotCount, setDotCount] = useState(0);
  const [select, setSelect] = useState(0);
  const navigate = useNavigate();
  const handleSelect = (num) => {
    if (select === num) {
      setSelect(0);
    } else {
      setSelect(num);
    }
  };

  // 점 애니메이션 (... 깜빡이는 효과)
  useEffect(() => {
    const interval = setInterval(() => {
      setDotCount((prev) => (prev + 1) % 4);
    }, 500);
    return () => clearInterval(interval);
  }, []);

  const movePage = (path) => {
    navigate(path);
  };

  const containerStyle = {
    width: '100%',
    height: '60vh', // 🔹 세로 크기 줄임
    background: '#f8f8f8',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    fontFamily: "'Pretendard', 'Noto Sans KR', sans-serif",
    color: '#202632',
    textAlign: 'center',
  };

  const logoStyle = {
    fontSize: '26px',
    fontWeight: '700',
    color: '#00a45a', // 🔹 포인트 녹색
    letterSpacing: '1px',
    marginBottom: '10px',
  };

  const titleStyle = {
    fontSize: '28px',
    fontWeight: '700',
    marginBottom: '10px',
  };

  const subStyle = {
    fontSize: '16px',
    color: '#555',
    marginBottom: '15px',
  };

  const dotWrapperStyle = {
    height: '30px', // 🔹 높이 고정 → 점 위치 고정
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '24px',
    color: '#00a45a',
    fontWeight: '700',
    letterSpacing: '3px',
  };

  return (
    <div className="sub_wrap">
      <div className="sub_back">
        <div className="sub_banner_area">
          <div className="sub_banner_back">
            <div className="navi_text">
              <div className="home_icon_sub"></div>
              {'> '}사업분야{' > '}기업 지원 사업
            </div>
            <div className="banner_main_text">기업 지원 사업</div>
          </div>
        </div>
        <div className="navi_area">
          <div className="navi_back">
            <div className="navi_box business_field" onClick={() => handleSelect(1)}>
              <div className="navi_main_text">기업지원사업</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 1 && 'active'}`}>
                <div className="select_row" onClick={() => movePage('/fusionSupportProgram')}>
                  산학융합지구조성사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/chungnamInnovationProject')}>
                  기업지원사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/localIndustryTalentDevelopment')}>
                  인재양성사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/YouthEmploymentSupport')}>
                  창업육성사업
                </div>
              </div>
            </div>
            <div className="navi_box enterprise" onClick={() => handleSelect(2)}>
              <div className="navi_main_text">산업단지 기숙사 임차지원 사업</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 2 && 'active'}`}>
                <div className="select_row" onClick={() => movePage('/business/chungnamInnovationProject')}>
                  충남지역혁신프로젝트 사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/chungnamInnovationCluster')}>
                  충남지역혁신클러스터
                </div>
                <div className="select_row" onClick={() => movePage('/business/carbonNeutralInfrastructure')}>
                  탄소중립실증인프라구축사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/EnergyGrowthSupport')}>
                  에너지 동반성장 상생혁력지원 사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/LocalYouthJob')}>
                  충남 지역주도형 청년일자리지원 사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/YouthJobIncentive')}>
                  청년일자리 도약장려금지원사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/SMECenterSupport')}>
                  중소기업지원센터지원 사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/DormLeaseSupport')}>
                  산업단지 기숙사 임차지원 사업
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="sub_main_area temporary">
          <SubTab category={category} />
          {/* 🔹 공통으로 돌려 쓸 카드 헤더(리디자인 영역) */}
          <div className="business-hero">
            <div className="business-hero-inner">
              <p className="business-hero-tag">Local Youth Employment Support Program</p>
              <h2 className="business-hero-title">지역주도형 청년일자리지원 사업</h2>
              <p className="business-hero-period">사업기간 : (계속사업) 2023. 3. ~ 2026. 3.</p>
              <p className="business-hero-period" style={{ color: 'red' }}>
                (해당 사업은 인원 모집 등이 끝난 마무리되는 사업이므로 참고 부탁드립니다.)
              </p>
            </div>
          </div>
          <div className="sub_main_back">
            <div className="business_title"></div>
            <div className="vision_container">
              <div className="vision_title_box nonline">
                <div className="logo_box">
                  <div className="logo_img"></div>
                </div>
                <div className="title_text">사업내용</div>
              </div>
              <div className="business_img_box">
                <div className="local-youth-job-img1"></div>
              </div>
              <div className="vision_title_box nonline">
                <div className="logo_box">
                  <div className="logo_img"></div>
                </div>
                <div className="title_text">추진체계</div>
              </div>
              <div className="propulsion_img_box">
                <div className="local-youth-job-img2"></div>
              </div>
              <div className="vision_title_box nonline">
                <div className="logo_box">
                  <div className="logo_img"></div>
                </div>
                <div className="title_text">사업목표</div>
              </div>
              <div className="objective_box">
                <p className="objective_title first">
                  지역 경제구조변화에 따라 선제적으로 대응하고 청년의 적합한 일자리를 발굴·제공하여 지속가능한
                  경제활동을 지원하며 지역정착을 조기 유도하여 지역과 함께 상생하고자 함
                </p>
              </div>
              <div className="vision_title_box nonline">
                <div className="logo_box">
                  <div className="logo_img"></div>
                </div>
                <div className="title_text">최종 성과</div>
              </div>
              <div className="local_final_result_box">
                <div className="project-result-box table-container ">
                  <table className="project-result-table">
                    <thead>
                      <tr>
                        <th style={{ width: '20%' }}>구분</th>
                        <th style={{ width: 'calc((100% - 33.333%) / 3)' }}>기타</th>
                        <th style={{ width: 'calc((100% - 33.333%) / 3)' }}>세부 사업 내용</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <td rowSpan={2}>2025년</td>
                        <td>기업지원(20개사)</td>
                        <td>참여청년 인건비 지원 20명</td>
                      </tr>

                      <tr>
                        <td>청년지원(20명)</td>
                        <td>
                          참여청년 교통비, 지역정착문화비 지원 20명
                          <br />
                          참여청년 인센티브 지원 9명
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocalYouthJob;
